import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import IconButton from '@mui/material/IconButton';
import type React from 'react';

type SortDirection = 'asc' | 'desc';

interface DownwardUpwardArrowsProps {
  enabledArrow: SortDirection;
  onArrowClick: (direction: SortDirection) => void;
}

const DownwardUpwardArrows: React.FC<DownwardUpwardArrowsProps> = ({ enabledArrow, onArrowClick }) => {
  return (
    <div style={{ display: 'flex' }}>
      <IconButton id="cyp-desc-arrow-icon" onClick={() => onArrowClick('desc')} size="large">
        <ArrowDownwardIcon color={enabledArrow === 'desc' ? 'inherit' : 'disabled'} />
      </IconButton>
      <IconButton onClick={() => onArrowClick('asc')} size="large">
        <ArrowUpwardIcon id="cyp-asc-arrow-icon" color={enabledArrow === 'asc' ? 'inherit' : 'disabled'} />
      </IconButton>
    </div>
  );
};

export default DownwardUpwardArrows;
